import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import axios from "axios";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import PageFour from "./PageFour";
import LoadingPage from "./LoadingPage";

const PageEight = ({ idJadwalCbt, idKelas, kodeTahunAjaran, schoolName }) => {
    const [fetching, setFetching] = useState(false);
    const [assesmentSiswa, SetAssesmentSiswa] = useState([]);
    const [headerMapel, SetHeaderMapel] = useState([]);
    const [openPage, setOpenPage] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_EIGHT, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                })
                .catch(function (error) {
                    console.error("Error Response Page Eight", error);
                });

            if (response) {
                if (response.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Eight ", responseAPI);
                    console.log("====================================");

                    SetAssesmentSiswa(responseAPI.listAsessmentSiswa);
                    SetHeaderMapel(responseAPI.listHeaderMataPelajaran);
                }
                setFetching(false);
                // setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <div>
            <div className="report-page">
                <div className="header-second-page">
                    <GridInline width={"100%"}>
                        <GridInline width={"80%"}>
                            <LabelTitle label={"Hasil Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                            <LabelTitle label={schoolName} size={18} bolder={500} color={"#fff"} />
                        </GridInline>
                        <GridInline width={"20%"}>
                            <div
                                style={{
                                    border: "2px solid #fff",
                                    padding: 5,
                                    textAlign: "center",
                                    borderRadius: 10,
                                }}
                            >
                                <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                            </div>
                        </GridInline>
                    </GridInline>
                </div>
                <Gap height={20} />
                <div className="section-three" style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <div className="result">
                        <GridInline width={"100%"}>
                            <LabelTitle label={"Rekapitulasi Siswa Belum Menyelesaikan Keseluruhan Asesmen"} size={18} bolder={700} color={"#212529"} />
                        </GridInline>
                        <Gap height={20} />
                        <div className="rekap-table">
                            <Table size="sm" style={{ fontSize: 14 }}>
                                <thead style={{ backgroundColor: "#E9ECEF", fontSize: 15, textAlign: "center" }}>
                                    <tr>
                                        <th
                                            width="150"
                                            height="50"
                                            colSpan={2}
                                            style={{
                                                textAlign: "left",
                                                paddingLeft: 15,
                                            }}
                                        >
                                            Nama Siswa
                                        </th>
                                        {headerMapel.map((mapel, i) => {
                                            return (
                                                <th key={i} width={30}>
                                                    {mapel.deskripsi}
                                                </th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                {assesmentSiswa.map((siswa, b) => {
                                    return (
                                        <>
                                            <tr
                                                width="100%"
                                                height="40"
                                                style={{
                                                    backgroundColor: "#F8F9FA",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <td>{b + 1}</td>
                                                <td
                                                    style={{
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    {siswa.namaSiswa}
                                                </td>
                                                {siswa.listAsessment.map((score, d) => {
                                                    return (
                                                        <>
                                                            {score.akademik == true && score.status == true ? (
                                                                <td>{score.skor}</td>
                                                            ) : score.akademik == true && score.status == false ? (
                                                                <td>
                                                                    <b style={{ color: "red" }}>X</b>
                                                                </td>
                                                            ) : score.akademik == false && score.status == true ? (
                                                                <td>
                                                                    <img src="/assets/image/pemetaan/bi_check.png" width={"80%"} />
                                                                </td>
                                                            ) : (
                                                                <td>
                                                                    <b style={{ color: "red" }}>X</b>
                                                                </td>
                                                            )}
                                                        </>
                                                    );
                                                })}
                                            </tr>
                                        </>
                                    );
                                })}
                            </Table>
                        </div>
                    </div>
                </div>
                {/* <Gap height={40} />
                <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={dateTime} />
                </div> */}
            </div>
        </div>
    );
};

export default PageEight;
